document.addEventListener('DOMContentLoaded', function() {
  console.log('Infinite Scroll Initialized');

  let infiniteScrollElement = document.getElementById('infinite-scroll-pagination');
  if (!infiniteScrollElement) {
    console.error('Infinite Scroll Pagination Element Not Found');
    return;
  }

  let maxPages = parseInt(infiniteScrollElement.getAttribute('data-max-pages'));
  let currentPage = 1;
  let nextPageUrl = infiniteScrollElement.getAttribute('data-next-page-url');
  let isLoading = false;

  console.log('Max Pages:', maxPages);
  console.log('Initial Next Page URL:', nextPageUrl);

  function loadNextPage() {
    if (isLoading || !nextPageUrl || currentPage >= maxPages) {
      console.log('Stopping Infinite Scroll: isLoading:', isLoading, 'nextPageUrl:', nextPageUrl, 'currentPage:', currentPage);
      return;
    }

    isLoading = true;
    console.log('Loading next page:', nextPageUrl);

    fetch(nextPageUrl)
      .then(response => {
        if (!response.ok) {
          console.error('Failed to fetch the next page:', response.status);
          return response.text();
        }
        return response.text();
      })
      .then(data => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, 'text/html');

        // Log the HTML response to check for issues in the content
        console.log('Fetched HTML:', doc);

        // Use .product-card to target each product item
        let newProducts = doc.querySelectorAll('product-card'); // Adjust this selector for your custom product card elements
        console.log('New products found:', newProducts.length);

        // Now use .product-list to target the product container
        let productContainer = document.querySelector('.product-list'); // Updated the container selector
        if (!productContainer) {
          console.error('Product container not found. Please check the container selector.');
          return;
        }

        if (newProducts.length > 0) {
          console.log('Appending new products to container:', productContainer);
          newProducts.forEach(product => {
            productContainer.appendChild(product);
          });

          // Update next page URL
          let newPaginationElement = doc.getElementById('infinite-scroll-pagination');
          if (newPaginationElement) {
            nextPageUrl = newPaginationElement.getAttribute('data-next-page-url');
            console.log('Updated nextPageUrl:', nextPageUrl);
            currentPage++;
          } else {
            console.log('No more pages to load');
            nextPageUrl = null; // No further pages
          }
        } else {
          console.log('No new products found in the fetched HTML.');
        }

        isLoading = false;
      })
      .catch(error => {
        console.error('Error during fetch:', error);
        isLoading = false;
      });
  }

  window.addEventListener('scroll', function() {
    let scrollPosition = window.scrollY + window.innerHeight;
    let documentHeight = document.documentElement.scrollHeight;

    // Log the scroll and document height values for debugging
    console.log('Scroll Position:', scrollPosition, 'Document Height:', documentHeight);

    // Trigger next page load if user scrolled near the bottom
    if (scrollPosition >= documentHeight - 1000 && !isLoading) {
      console.log('Condition met, triggering loadNextPage');
      loadNextPage();
    } else {
      console.log('Condition not met. scrollPosition:', scrollPosition, 'documentHeight:', documentHeight);
    }
  });
});
